const Input = ({ label, value, onChange, type = 'text', id, className, disabled, labelClassName }) => {
  return (
    <div className={'flex items-center gap-2 font-montserrat text-lg ' + (className || '')}>
      <label htmlFor={id} className={'font-semibold text-red-1 whitespace-nowrap ' + (labelClassName || '')}>
        {label}
      </label>
      <input
        id={id}
        type='text'
        value={value}
        onChange={onChange}
        className='p-1 outline-none focus:outline-none border-2 rounded focus:border-red-2 transition-all w-full'
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
